import { render, staticRenderFns } from "./Instr.vue?vue&type=template&id=79a96984&scoped=true"
import script from "./Instr.vue?vue&type=script&lang=js"
export * from "./Instr.vue?vue&type=script&lang=js"
import style0 from "./Instr.vue?vue&type=style&index=0&id=79a96984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a96984",
  null
  
)

export default component.exports